import { useSelector } from "react-redux";
import GridItem from "components/common/GridItem";
import GridContainer from "components/common/GridContainer";
import Box from "@mui/material/Box";
import { Button, InputAdornment, Stack, TextField } from "@mui/material";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

function Greeting({ profile }) {
    const hour = new Date().getHours();

    let timeOfDay;
    if (hour < 12) {
        timeOfDay = "Good Morning";
    } else if (hour < 18) {
        timeOfDay = "Good Afternoon";
    } else {
        timeOfDay = "Good Evening";
    }

    return (
        <h2>
            {timeOfDay} {profile?.fullName}
        </h2>
    );
}

export default function Home() {
    // const dispatch = useDispatch();
    const profile = useSelector((state) => state.user.profile);

    const [isFocused, setIsFocused] = useState(false);
    const [keyword, setKeyword] = useState("");
    const onKeywordChange = (value) => {
        console.log("onKeywordChange", value);
    };
    const onNew = () => console.log("ne");

    const searchField = () => {
        return (
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    mb: 2.5,
                    p: "4px 6px 4px 16px",
                    backgroundColor: isFocused ? "#ffffff" : "#eef3f8",
                    borderRadius: "50px",
                    width: isFocused ? "480px" : "340px",
                    m: "auto",
                    border: isFocused
                        ? "1px solid #1d52bc"
                        : "1px solid #e2e8f0",
                    boxShadow: isFocused
                        ? "0 0 0 3px rgba(29, 82, 188, 0.15)"
                        : "none",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                }}
            >
                <TextField
                    size="small"
                    placeholder="Search"
                    value={keyword}
                    onChange={(event) => onKeywordChange(event.target.value)}
                    variant="standard"
                    fullWidth
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    slotProps={{
                        input: {
                            disableUnderline: true,
                            startAdornment: (
                                <InputAdornment
                                    position="start"
                                    sx={{
                                        color: isFocused
                                            ? "#1d52bc"
                                            : "#8a99ad",
                                        mr: 1,
                                        transition: "color 0.2s ease"
                                    }}
                                >
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            ),
                            sx: {
                                fontSize: "0.95rem",
                                color: "#334155",
                                fontWeight: 400,
                                "&::before, &::after": {
                                    display: "none !important"
                                },
                                "& input": {
                                    padding: "6px 0"
                                },
                                "& input::placeholder": {
                                    color: "#8a99ad",
                                    opacity: 1
                                }
                            }
                        }
                    }}
                />

                <Button
                    variant="contained"
                    onClick={onNew}
                    disableElevation
                    sx={{
                        borderRadius: "50px",
                        px: 3.5,
                        py: 1,
                        minWidth: "90px",
                        fontWeight: 700,
                        fontSize: "0.85rem",
                        letterSpacing: "0.6px",
                        textTransform: "uppercase",
                        backgroundColor: "#1d52bc",
                        whiteSpace: "nowrap",
                        "&:hover": {
                            backgroundColor: "#153e90"
                        }
                    }}
                >
                    Search
                </Button>
            </Stack>
        );
    };

    return (
        <div style={{ margin: "24px 120px" }}>
            <Box>
                <div style={{ marginBottom: 36 }}>
                    <GridContainer direction="column" justify="center">
                        <GridItem sx={{ flex: 1, textAlign: "center" }}>
                            {Greeting({ profile })}
                        </GridItem>
                        <GridItem>{searchField()}</GridItem>
                    </GridContainer>
                </div>

                <GridContainer noWrap alignItems="center" spacing={4}>
                    <GridItem sx={{ flex: 1 }}>
                        <GridContainer direction="column" spacing={1}>
                            <GridItem>
                                <GridContainer direction="column" spacing={0}>
                                    <GridItem>
                                        <h3 style={{ padding: 4, margin: 0 }}>
                                            Awaiting your actions
                                        </h3>
                                    </GridItem>
                                    <GridItem>
                                        <GridContainer
                                            direction="row"
                                            spacing={3}
                                            card
                                        >
                                            <GridItem>
                                                No actions needed
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                            <GridItem>
                                <GridContainer direction="column" spacing={0}>
                                    <GridItem>
                                        <h3 style={{ padding: 4, margin: 0 }}>
                                            Timely suggestions
                                        </h3>
                                    </GridItem>
                                    <GridItem>
                                        <GridContainer
                                            direction="row"
                                            spacing={3}
                                            card
                                        >
                                            <h2>Hello, you haven't time-on</h2>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem sx={{ flex: 1, height: "100%" }}>
                        <GridContainer direction="column" spacing={0}>
                            <GridItem>
                                <h3 style={{ padding: 4, margin: 0 }}>
                                    Announcements
                                </h3>
                            </GridItem>
                            <GridItem>
                                <GridContainer
                                    direction="column"
                                    spacing={6}
                                    card
                                >
                                    <GridItem>Coming soon</GridItem>
                                    <GridItem>Weather</GridItem>
                                    <GridItem>Forex</GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </Box>
        </div>
    );
}
